import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import AchievementsLiveLessonsSkeleton from './AchievementsLiveLessonsSkeleton'
import AchievementsLiveLessonsStatsPlaceholder from './subcomponents/AchievementsLiveLessonsStats/AchievementsLiveLessonsStatsPlaceholder'
import AchievementsLiveLessonsListPlaceholder from './subcomponents/AchievementsLiveLessonsList/AchievementsLiveLessonsListPlaceholder'

const AchievementsLiveLessonsPlaceholder = () => {
  return (
    <AchievementsLiveLessonsSkeleton
      headerSection={
        <LoadingBox width="30%" maxWidth="100%" mb="1x" borderRadius="1x">
          &nbsp;
        </LoadingBox>
      }
      statsSection={<AchievementsLiveLessonsStatsPlaceholder />}
      listSection={<AchievementsLiveLessonsListPlaceholder />}
    />
  )
}

export default AchievementsLiveLessonsPlaceholder
